// Generated by CoffeeScript 2.7.0
var Flow;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js';

import FieldList from 'trunks/vue/admin/components/fields/list/fieldable.js';

import FormableMixin from 'trunks/vue/admin/compositions/formables/mixin.js';

export default Flow = Vue.extend({
  mixins: [FormableMixin],
  components: {
    'field-list': FieldList,
    editor: RichTextEditor
  },
  props: {
    resource: {
      type: String,
      default: '/admin/yet_another_workflow/flows'
    },
    type: {
      type: String,
      default: 'flow'
    }
  },
  data: function() {
    return {
      flow: {
        title: '',
        fields: []
      }
    };
  },
  template: `<div class="formable-edit-view">
  <div class="formable-base-content">
    <div class="formable-title">
      <input type="text" placeholder='未命名流程' v-model.trim='flow.title' />
    </div>
    <div class="formable-description">
      <editor ref='editor' :value='flow.html_body' @valueChanged='updateBodyContent' placeholder='消息正文' scrollingContainer='main>.main-content' />
    </div>
  </div>
  <field-list :fields='flow.fields'
              :fieldable='flow'
              ref='fieldsView'
              @fieldLengthChanged='fieldLengthChangedFunc' />
  <div class="formable-actions" ref='formableActions'>
    <div class="slp-tooltip right" data-title="添加表项">
      <div class="action-item clickable" @click='addNewField'>
        <i class="slp-plus-circle"></i>
      </div>
    </div>
    <div class="slp-tooltip right" data-title="添加章节">
      <div class="action-item clickable" @click='addSectionBreak'>
        <i class="slp-text-square"></i>
      </div>
    </div>
  </div>
</div>`,
  methods: {
    addNewField: function() {
      return this.$refs.fieldsView.addNewField();
    },
    addSectionBreak: function() {
      return this.$refs.fieldsView.addNewField('Field::SectionBreak');
    },
    updateBodyContent: function(new_value) {
      return this[this.type].html_body = new_value;
    },
    save: function() {
      var ref;
      return (ref = this.flow.update()) != null ? ref.success(() => {
        newAlertify('保存成功', {
          type: 'success'
        });
        return this.$emit('flowSaved');
      }) : void 0;
    },
    fieldLengthChangedFunc: function() {
      return this.$emit('fieldLengthChanged');
    },
    validateFields: function() {
      var errors;
      errors = this.$refs.fieldsView.validate();
      return this.erros = _.extend(this.errors, errors);
    },
    _validate: function() {
      this.validateTitle();
      return this.validateFields();
    }
  }
});
